// Analytics stub - logs events to console
// In production, replace with real analytics service (GA, Mixpanel, etc.)

export const track = (event, payload = {}) => {
  if (import.meta.env.DEV) {
    console.log('[Analytics]', event, payload)
  }

  // In production, you would send to your analytics service:
  // window.gtag?.('event', event, payload)
  // or
  // mixpanel.track(event, payload)
}

// Common event helpers
export const trackPageView = (path) => {
  track('page_view', { path })
}

export const trackEpisodePlay = (episodeSlug, episodeTitle) => {
  track('episode_play', {
    episode_slug: episodeSlug,
    episode_title: episodeTitle,
  })
}

export const trackEpisodePause = (episodeSlug, currentTime) => {
  track('episode_pause', {
    episode_slug: episodeSlug,
    current_time: currentTime,
  })
}

export const trackSubscribeClick = (platform) => {
  track('subscribe_click', {
    platform,
  })
}

export const trackFormSubmit = (formType) => {
  track('form_submit', {
    form_type: formType,
  })
}

export const trackSocialShare = (platform, episodeSlug) => {
  track('social_share', {
    platform,
    episode_slug: episodeSlug,
  })
}

export const trackSearch = (query, resultsCount) => {
  track('search', {
    query,
    results_count: resultsCount,
  })
}
